export default __webpack_public_path__ + "static/media/6S.e04a54c4.png";